module.exports = __webpack_public_path__ + "img/70518d6.png";